import { produce } from "immer";
import {
  FETCH_EVALUATIONS,
  FETCH_EVALUATIONS_SUCCESS,
  FETCH_EVALUATIONS_FAILURE,
  FETCH_EVALUATION,
  FETCH_EVALUATION_SUCCESS,
  FETCH_EVALUATION_FAILURE,
  SAVE_EVALUATION,
  SAVE_EVALUATION_SUCCESS,
  SAVE_EVALUATION_FAILURE,
  UPDATE_EVALUATION,
  UPDATE_EVALUATION_SUCCESS,
  UPDATE_EVALUATION_FAILURE,
  UPDATE_PLAN_EVALUATION,
  UPDATE_PLAN_EVALUATION_SUCCESS,
  UPDATE_PLAN_EVALUATION_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingEvaluations: false,
  evaluations: [],
  isFetching: false,
  currentEvaluation: {},
  isSaving: false,
  isUpdating: false,
  isUpdatingPlanEvaluation: false,
};

const ResidentEvaluationReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_EVALUATIONS:
        draft.isFetchingEvaluations = true;
        draft.evaluations = [];
        break;
      case FETCH_EVALUATIONS_SUCCESS:
        draft.isFetchingEvaluations = false;
        draft.evaluations = action.payload;
        break;
      case FETCH_EVALUATIONS_FAILURE:
        draft.evaluations = [];
        draft.isFetchingEvaluations = false;
        break;
      // Single
      case FETCH_EVALUATION:
        draft.isFetching = true;
        draft.currentEvaluation = {};
        break;
      case FETCH_EVALUATION_SUCCESS:
        draft.isFetching = false;
        draft.currentEvaluation = action.payload;
        break;
      case FETCH_EVALUATION_FAILURE:
        draft.isFetching = false;
        break;
      // Save
      case SAVE_EVALUATION:
        draft.isSaving = true;
        break;
      case SAVE_EVALUATION_SUCCESS:
        draft.isSaving = false;
        break;
      case SAVE_EVALUATION_FAILURE:
        draft.isSaving = false;
        break;
      // Update
      case UPDATE_EVALUATION:
        draft.isUpdating = true;
        break;
      case UPDATE_EVALUATION_SUCCESS:
        draft.isUpdating = false;
        break;
      case UPDATE_EVALUATION_FAILURE:
        draft.isUpdating = false;
        break;
      // Update Plan Evaluation
      case UPDATE_PLAN_EVALUATION:
        draft.isUpdatingPlanEvaluation = true;
        break;
      case UPDATE_PLAN_EVALUATION_SUCCESS:
        draft.isUpdatingPlanEvaluation = false;
        break;
      case UPDATE_PLAN_EVALUATION_FAILURE:
        draft.isUpdatingPlanEvaluation = false;
        break;
      default:
        return state;
    }
  });

export default ResidentEvaluationReducer;
